import { useTranslation } from "react-i18next";
import { useModule } from "@/context/ModuleContext";
import { Zap, Network } from "lucide-react";

/**
 * Top-bar module switcher — always visible so the user knows which module
 * they're working on. LV and Electrical never mix visually.
 */
export default function ModuleSwitcher() {
  const { module, setModule } = useModule();
  const { i18n } = useTranslation();
  const es = i18n.language?.startsWith("es");

  return (
    <div className="inline-flex items-center gap-1 bg-white border border-slate-200 rounded-full p-1 shadow-sm"
         data-testid="global-module-switcher">
      <button
        onClick={() => setModule("low_voltage")}
        data-testid="module-switch-low_voltage"
        className={`px-3.5 py-1.5 rounded-full text-xs font-mono uppercase tracking-wider inline-flex items-center gap-1.5 transition-all ${
          module === "low_voltage"
            ? "bg-[#003366] text-white shadow"
            : "text-slate-600 hover:bg-slate-50"
        }`}>
        <Network size={12} /> {es ? "Bajo Voltaje" : "Low Voltage"}
      </button>
      <button
        onClick={() => setModule("electrical")}
        data-testid="module-switch-electrical"
        className={`px-3.5 py-1.5 rounded-full text-xs font-mono uppercase tracking-wider inline-flex items-center gap-1.5 transition-all ${
          module === "electrical"
            ? "bg-[#EAB308] text-white shadow"
            : "text-slate-600 hover:bg-slate-50"
        }`}>
        <Zap size={12} /> {es ? "Eléctrico" : "Electrical"}
      </button>
    </div>
  );
}
